import axios from 'axios';
import {
  REPORTS_API_KEY,
  JOB_NOTE_RESOURCE,
  API_KEY_JOBS,
  API_URL_JOBS,
} from '../constants';

export function* getJobNote(jobId) {
  const response = yield axios({
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': REPORTS_API_KEY,
    },
    url: `${JOB_NOTE_RESOURCE}/${jobId}`,
    validateStatus(status) {
      return status >= 200 && status <= 403; // default
    },
  });
  return response;
}

export function* postJobNote(payload) {
  const response = yield axios({
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': REPORTS_API_KEY,
    },
    data: payload,
    url: `${JOB_NOTE_RESOURCE}`,
    validateStatus(status) {
      return status >= 200 && status <= 403; // default
    },
  });
  return response;
}

export function* updateUserBusiness(
  accessToken,
  businessNumber,
  businessDetails,
) {
  const response = yield axios({
    method: 'PUT',
    data: businessDetails,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
      'x-api-key': API_KEY_JOBS,
    },
    url: `${API_URL_JOBS}/users/${businessNumber}/businesses/${businessNumber}`,
  });
  return response;
}

export function* createActivity(
  accessToken,
  builderId,
  username,
  activityName,
) {
  // get the user profile
  const response = yield axios({
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
      'x-api-key': API_KEY_JOBS,
    },
    data: {
      builderId,
      username,
      activityName,
    },
    url: `${API_URL_JOBS}/activityLog/admin`,
    validateStatus(status) {
      return status >= 200 && status <= 403; // default
    },
  });
  console.log({ response }, 'create actiivty');
  return response;
}
